import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, inject } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { environment } from '@env/environment';
import { Subscription } from 'rxjs';
import { GuiSpinnerService } from './gui';
import { ToastsComponent } from './gui/components/toasts/toasts.component';
import { ConfirmDialogComponent } from './gui/components/confirm-dialog/confirm-dialog.component';
import { SpinnerComponent } from './gui/components/spinner/spinner.component';
import { Router, RouterOutlet } from '@angular/router';
import Hotjar from '@hotjar/browser';
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet, ToastsComponent, ConfirmDialogComponent, SpinnerComponent],
})
export class AppComponent implements OnInit, OnDestroy {
    private translateService = inject(TranslateService);
    private guiSpinnerService = inject(GuiSpinnerService);
    private router = inject(Router);
    private titleService = inject(Title);

    subscriptions: Subscription = new Subscription();

    //  implements OnInit, OnDestroy {
    constructor() {
        // @ts-expect-error: private option not yet exposed for public use
        this.router.canceledNavigationResolution = 'computed';
    }
    favIcon: HTMLLinkElement = document.querySelector('#favIcon');

    ngOnInit(): void {
        this.guiSpinnerService.init();
        this.translateService.addLangs(environment.supportedLanguages);
        this.translateService.setDefaultLang(environment.defaultLanguage);
        this.translateService.use(environment.defaultLanguage);
        this.titleService.setTitle(environment.title);

        if (environment.logo.favicon === false) {
            this.favIcon.setAttribute('href', 'assets/favicons/favicon-default.png');
        }

        if (environment.hotjar.enabled) {
            Hotjar.init(environment.hotjar.siteid, environment.hotjar.version);
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }
}
